export class NumericFault extends Error {
    code = "numeric-fault";
    constructor(message) {
        super(message);
        this.name = "NumericFault";
    }
}
export function requireFinite(adapter, value, operation) {
    if (!adapter.isFinite(value))
        throw new NumericFault(`${operation} produced a non-finite value`);
    return value;
}
//# sourceMappingURL=types.js.map